import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewSubadminLayer from "../../components/ViewSubadminLayer";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ViewSubadminPage = () => {
  const { subAdminId } = useAuth();
  return (
    <>
      <MasterLayout>
        <Breadcrumb title={subAdminId ? "My Profile" : "View Subadmin"} />
        <ViewSubadminLayer />
      </MasterLayout>
    </>
  );
};

export default ViewSubadminPage;
